<template>
	<div full-height>
		<div class="display_wrapper" id="non-printable">

			<v-toolbar flat fixed>
			    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

			    <v-toolbar-title class="white--text">Stock Transfer</v-toolbar-title>

			    <v-spacer></v-spacer>

			    <!-- <v-btn round-borders outline @click="fn_edit" v-if="displayData && displayData.status==1">edit</v-btn> -->
			    <v-btn icon @click="fn_edit" v-if="displayData && displayData.status==1">
			    	<v-icon>edit</v-icon>
			    </v-btn>

				<v-btn icon @click="fn_preview" v-if="displayData">
			    	<!-- <v-icon>remove_red_eye</v-icon> -->
			    	<img src="../../../../assets/icon_preview.svg" alt="preview_icon"></img>
			    </v-btn>

			    <!-- <v-btn icon @click="fn_getBottomMenu">
			      <v-icon>more_vert</v-icon>
			    </v-btn> -->

			</v-toolbar>

			<div full-height grey-back class="display hasToolbar hasBigFooterWithExtention">

				<v-alert :value="displayData && displayData.status==0" type="warning" transition="slide-y-transition">
					<span>This transaction has been cancelled!</span>
				</v-alert>

				<v-list nopadding>
				  	<v-list-tile>	
			          	<v-list-tile-content>
			              <v-list-tile-title>{{displayData.mergeTransactionNumber}}</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>{{displayData.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-action>
				    </v-list-tile>
				</v-list>

				<!-- <v-divider></v-divider> -->

                <v-card flat margin-top-ten>
                    <v-card-text font20>
                        {{ displayData.fromGodownName }} <v-icon style="margin-top: -10px;">chevron_right</v-icon> {{ displayData.toGodownName }}
                    </v-card-text>
                </v-card>

				
				<v-list two-line nopadding margin-top-ten v-if="displayData.trProducts && displayData.trProducts.length">

                    <!-- {{ displayData }} -->

					<div grey-back v-for="(item, index) in displayData.trProducts" :key="index">
						<v-list-tile class="right-subtitle-tile white-background">
						    <v-list-tile-content>

						      <v-list-tile-title class="mb-1">{{item.productName}}</v-list-tile-title>
						      	<v-list-tile-sub-title class="mb-1">
						      		{{item.productVariants[0].qty}} {{ item.productVariants[0].unitName }}
						   		</v-list-tile-sub-title>

						      <!-- <v-list-tile-sub-title v-if="$root.TransactionSettings.mrpWiseStock">
						      	<span>MRP: <b>{{$root.numberToLocale(item.mrp)}}</b></span>
						      </v-list-tile-sub-title> -->
						    </v-list-tile-content>	

						    <!-- <v-list-tile-action style="padding-bottom:6px !important">&#8377; {{$root.numberToLocale(item.amount)}}</v-list-tile-action> -->
							<v-list-tile-action v-if="item.rate" style="align-items: right;">
								<div></div>
								&#8377; {{ $root.numberToLocale(item.rate * item.productVariants[0].qty) }}
                            </v-list-tile-action>
						</v-list-tile>

						<v-divider v-if="displayData.trProducts.length-1 != index"></v-divider>

						<template v-if="$root.TransactionSettings.enableBatch && item.transactionProductBatches && item.transactionProductBatches.length">
							<v-subheader class="white-background">{{ item.selectedBatchType == 2 ? '#Series' : 'Batches#' }}</v-subheader>
							<v-divider></v-divider>
							<div class="mb-2" v-for="(batch, batchIndex) in item.transactionProductBatches" :key="batchIndex">
								<v-card flat>
									<v-card-text>
										<v-layout class="batch_layout" row wrap>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
												<div light-opacity-color>Batch No.</div>
												<div>{{ batch.batchNumber }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
												<div light-opacity-color>Size</div>
												<div>{{ batch.batchSize }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
												<div light-opacity-color>MRP</div>
												<div>{{ batch.batchMRP }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
												<div light-opacity-color>Mfg. Date</div>
												<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
												<div light-opacity-color>Exp. Date</div>
												<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
												<div light-opacity-color>Purchase Rate</div>
												<div>{{ batch.purchaseRate }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
												<div light-opacity-color>Serial Number</div>
												<div>{{ batch.field1 }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
												<div light-opacity-color>IMEI Number</div>
												<div>{{ batch.field2 }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
												<div light-opacity-color>Part Number</div>
												<div>{{ batch.field3 }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
												<div light-opacity-color>Model Number</div>
												<div>{{ batch.field4 }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2>
												<div light-opacity-color>Quantity</div>
												<div>{{ batch.qty }}</div>
											</v-flex>
										</v-layout>
									</v-card-text>
								</v-card>
								<v-divider v-if="batchIndex != item.transactionProductBatches.length - 1"></v-divider>
							</div>
						</template>
						

					</div>
				</v-list>

				<!-- <v-list nopadding margin-top-ten v-if="displayData.transactionAddOns && displayData.transactionAddOns.length">
                    <v-subheader>Additional Charges</v-subheader>
                    <v-divider></v-divider>
                    <v-list-tile v-for="(item, index) in displayData.transactionAddOns" :key="0">
                        <v-list-tile-content>
                            <v-list-tile-title>{{item.addOnsName}}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            &#8377; {{ $root.numberToLocale(item.value) }}
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list> -->

			    <div v-if="displayData.notes" class="margin-top-ten">
					<v-list full-width nopadding>
					  	<v-list-tile>
				          	<v-list-tile-content>
				              	<v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
				            </v-list-tile-content>
					    </v-list-tile>
					</v-list>

					<v-divider></v-divider>

					<v-card flat class="note-card">
					  	<v-card-text font16 v-html="displayData.notes" white-space-pre-line></v-card-text>
					</v-card>
				</div>

				<div white-background class="pt-1 pb-1 mt-2 font16" style="position: sticky;bottom: 60px;width: 100%;">
					<v-layout row wrap v-if="displayData && displayData.transactionProducts && displayData.transactionProducts.length">
						<v-flex xs6 sm6 md6 pl-3 pt-1 pb-1>Total</v-flex>
						<v-flex xs6 sm6 md6 pr-3 pt-1 pb-1 right-align>&#8377; {{ $root.numberToLocale(totalAmount) }}</v-flex>
					</v-layout>
				</div>
				<v-footer white-background class="invoice-footer-actions">
					<!-- <v-layout row wrap v-if="displayData && displayData.transactionProducts && displayData.transactionProducts.length">
						<v-flex xs6 sm6 md6 pl-3 pt-1 pb-1>Total</v-flex>
						<v-flex xs6 sm6 md6 pr-3 pt-1 pb-1 right-align>&#8377; {{ $root.numberToLocale(totalAmount) }}</v-flex>
					</v-layout> -->

					<v-layout grid wrap text-xs-center>
						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('sharewhatsapp')">
							<div right-border>
								<div style="height:26px"><img src="../../../../assets/icon_whatsapp.svg" alt="whatapp_icon"></img></div>
						    	<div font11 class="font-weight-bold">Send</div>
							</div>	
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('share')">
						    <div right-border>
						    	<div><v-icon>share</v-icon></div>
						    	<div font11 class="font-weight-bold">Share</div>
						    </div>
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('print')">
						    <div right-border>
						    	<div><v-icon>print</v-icon></div>
						    	<div font11 class="font-weight-bold">Print</div>
						    </div>
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('pdf')">
						    <div right-border>
						    	<div><v-icon>vertical_align_bottom</v-icon></div>
						    	<div font11 class="font-weight-bold">Download</div>
						    </div>
						</v-flex>

					</v-layout>

					<div v-ripple class="pb-2 pt-2" center-align style="width:20%" white-background @click="fn_getBottomMenu">
						<div><v-icon>more_horiz</v-icon></div>
						<div font11 class="font-weight-bold">More</div>
		            </div>
					
				</v-footer>

			</div>

			<dialog-confirmation ref="ref_dialogCancelDeleteTransaction" :header="confirmationDialogHeader" :confirmationMessage="confirmationMessage" :actionMethod="fn_callCancelTransaction" :params="{type:actionType}" :displayView='true' okBtnText="Yes" cancelBtnText="No" icon="warning" iconClass="redcolor" textClass="redcolor"></dialog-confirmation>
			
			<v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>
		</div>

		<div id="printable" full-width>
			<print-template ref="ref_printTemplate" :data="printData" v-if="printData!=null"></print-template>
		</div>

		<!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->

		<v-snackbar v-model="snackbarOpenFile">
          File downloaded!
          <v-btn flat color="primary" @click.native="$root.fn_openDownloadedFile">Open</v-btn>
        </v-snackbar>
	</div>
</template>

<script>
const menuItem = require('../../../../config.js').configs.menuItem;
const transactionForms = require('../../../../config.js').configs.transactionForms;

import dialogConfirmation from '../../../dialogs/dialog_confirmation'

import printTemplate from '../../../invoice_templates/invoices/template301'

import {transactionMixin} from '../../transaction_mixin'

	export default{
		props:['settings'],
		mixins: [transactionMixin],
		data(){
			return{
				displayData:{},
				toolbarTitle:null,
				selectedNatureValue:null,
				snackbar:false,
				snackbar_msg:null,
				actionType:null,
				confirmationDialogHeader:null,
				confirmationMessage:null,
				printData:null
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation,
			'print-template': printTemplate
		},
		methods:{

			// fn_printData: function(){
			// 	this.fn_getPrintData();
			// 	AndroidRoutingTest.print();
			// },

			fn_preview: function(){
				this.fn_previewInvoice(true, "inventory", 'st', null, 'Stock Transfer');
			},

			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_bindInvoiceTemplate: function(type){

				if(this.disableAction){
					return;
				}

				this.disableAction = true;

				let self = this;
				setTimeout(function(){
					self.disableAction = false;
				},500);

				if(type=='sharewhatsapp'){
					this.fn_shareInvoice('sharewhatsapp');
				}
				else if(type=='print'){
					this.fn_getPrintData('StockTransferInvoiceData', this.displayData.transactionId, 'print');
				}
				else if(type=='pdf'){
					this.fn_getPrintData('StockTransferInvoiceData', this.displayData.transactionId, 'pdf');
				}
				else if(type=='share'){
					this.fn_shareInvoice('share');
				}
			},

			fn_shareInvoice: function(type){
				let shareObj = {};
				shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';
				// shareObj.shareType = this.displayData.primaryMobileNumber && type == 'sharewhatsapp' ? 'ShareOnWhatsApp' : 'Share';
				shareObj.subject = "Stock Transfer Details";
				shareObj.textMessage = this.$tShare('share.stockTransferMessage', {
					date: this.$moment(this.displayData.createdDate).format('DD-MMM-YYYY'),
					businessName: this.$root.CurrentBusiness.BusinessName
				});
				shareObj.type = 'pdf';
				this.fn_getPrintData('StockTransferInvoiceData', this.displayData.transactionId, 'pdf', shareObj);
			},

			fn_callCancelTransaction: function(paramObj){
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;

				let self = this;
				if(paramObj.type=='cancel'){
					this.fn_cancelTransaction(this.displayData.transactionId, this.displayData.transactionListId);	
				}
				else{
					// let transactionNumber = this.displayData.mergeTransactionNumber;
					this.fn_deleteTransaction(this.displayData.transactionId, this.displayData.transactionListId, function(status){
						if(status){
							// self.snackbar = true;
							// self.snackbar = '#'+transactionNumber+ ' deleted parmanently!.';
							self.showToast('Stock transfer deleted parmanently')
							self.$router.go(-1);
						}
						else{
							// self.snackbar = true;
							// self.snackbar = 'Something went wrong. Try again!.';	
							self.showToast("Something went wrong. Try again");
						}
					});
				}
			},

			fn_comingSoon: function () {
				// this.snackbar_msg = "Coming Soon..";
				// this.snackbar = true;
				this.showToast("Coming Soon...");
			},

			fn_getData: function (itemId) {
				let self = this;
				this.getData("GetStockTransfer", itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.displayData = JSON.parse(response);
                            self.displayData.trProducts = [];
                            for(let i=0; i<self.displayData.transactionProducts.length; i++){
                                let itemIndex  = self.displayData.trProducts.findIndex(item=>{return item.productId == self.displayData.transactionProducts[i].productId})
                                if(itemIndex==-1){
                                    self.displayData.trProducts.push(self.displayData.transactionProducts[i]);
                                }
                            }
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getGroupTotal: function (tp) {
				let total = 0;
				tp.variants.forEach(function (item) {
					total += item.amount;
				});
				tp.amount = total;
			},

			fn_getBottomMenu: function (tagId) {

				var bottomMenu = {"BottomMenu": [menuItem.delete]};

				// this.displayData.status==0 ? bottomMenu = {"BottomMenu": [menuItem.share, menuItem.delete]} : '';

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit' && this.displayData && this.displayData.transactionId){
					this.fn_edit();
				}
				else if(menuAction=='cancel'){
					// this.fn_cancelTransaction(this.displayData.transactionId, 'display');
					this.actionType = 'cancel';
					this.confirmationDialogHeader = "Cancel Transaction?";
					this.confirmationMessage = "Cancelled transaction cannot be uncancelled. Are you sure you want to cancel this transaction?"
					this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = true;
				}
				else if(menuAction=='delete'){
					this.actionType = 'delete';
					this.confirmationDialogHeader = "Delete Transaction?";
					this.confirmationMessage = "Deleted transaction cannot be restored. Are you sure you want to delete this transaction?"
					this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = true;
				}
				else if(menuAction=='share'){
					// this.fn_shareInvoice('share');
					this.fn_bindInvoiceTemplate('share');
				}
			},

			fn_edit: function () {
				this.$router.push({path:'/transactions/inventory/stocktransfer/items/'+this.displayData.transactionId+'/edit'});
			},

			// fn_closeDialog: function(){
			// 	this.$refs['ref_dialogPermission'].dialog_permission = false;
			// },

			fn_showWebView: function () {
				var viewObject = {};

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';
				var self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction, itemId) {
							self.fn_menuItemClick(tagId, menuId, menuAction, itemId)
						}
					}
				);
			},

			// fn_getPrintData: function(){
			// 	var self = this;
		 //  		this.getData('StockJournalPrintData', this.displayData.transactionId, 
			// 		{
			// 			onSuccess: function(response){
			// 	          	console.log(response);
			// 	          	self.printData = JSON.parse(response);
			// 	          	setTimeout(function(){
			// 	          		self.$refs['ref_printTemplate'].fn_init();
			// 	          	},300);
			// 	        }, 
			// 	        onError: function(error){
			// 	        	console.log(error);
			// 	        }
			// 		}
		 //        );
			// },
		},
		computed:{
			totalAmount: function(){
				let total = 0;
				if(this.displayData && this.displayData.transactionProducts && this.displayData.transactionProducts.length){
					for(let i=0; i<this.displayData.transactionProducts.length; i++){
						if(this.displayData.transactionProducts[i].rate){
							total += this.displayData.transactionProducts[i].rate * this.displayData.transactionProducts[i].productVariants[0].qty;
						}
					}
				}
				// diving total by 2 as transaction products are double for in and out entry
				return total / 2;
			}
		},
		mounted: function(){

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_onBackPress = this.fn_goBack;

			this.fn_showWebView();
	        
			if(this.$route.params && this.$route.params.tagId){
				this.fn_getData(this.$route.params.tagId);
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation){
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;
				// this.$refs['ref_dialogPermission'].dialog_permission = false;
				next(false);
			}
			else{
				next(true);	
			}
	    }
		// computed:{
		// 	transactionNumber: function () {
		// 		let prefix = this.displayData.prefix ? this.displayData.prefix + '/' : '';
	 //    		let suffix = this.displayData.suffix ? '/' + this.displayData.suffix : '';
	 //    		let transactionNumber = this.displayData.transactionNumber ? this.displayData.transactionNumber : '';
	 //    		return prefix + transactionNumber + suffix;
		// 	}
		// }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/stock_transfer/display.vue